import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  /* width: calc(100% - 50px); */
  display: inline-flex;
  flex-direction: column;
  gap: ${grid.sm};
  margin: ${grid.md} 0 0 ${grid.xl};
`;

export const DownloadFileButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  gap: ${grid.xs};
  text-align: left;

  span {
    word-break: break-word;
  }
`;
